<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">{{title}}</p>
            <button class="button" type="button" @click="$parent.close()">Cerrar</button>
        </header>
        <section class="modal-card-body is-paddingless">
            <vue-pdf-viewer class="is-marginless visor--pdf" :url="url">
            </vue-pdf-viewer>
        </section>
    </div>
</template>

<script>
import VuePDFViewer from 'vue-instant-pdf-viewer'

export default {
  data () {
    return {
      loading: true
    }
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Visor PDf'
    },
    url: {
      type: String,
      required: true
    }
  },
  components: {
    'vue-pdf-viewer': VuePDFViewer
  }
}
</script>
<style scoped>
  .visor--pdf {
    height: calc(100vh - 80px) !important;
  }
</style>
